export const getQuestionTimerColor = (maxSeconds: number, seconds: number) => {
  const ratio = seconds / maxSeconds;

  if (ratio >= 0.5) return 'status.started';
  if (ratio < 0.5 && ratio >= 0.2) return 'orange.contrast';
  return 'red.contrast';
};
export const getQuestionStatusLabel = (maxSeconds: number, seconds: number) => {
  const ratio = seconds / maxSeconds;

  if (ratio >= 0.5) return 'зеленый';
  if (ratio < 0.5 && ratio >= 0.2) return 'оранжевый';
  return 'красный';
};
